import React, { FunctionComponent, useState } from "react";

import { useAppContext } from "../../state";
import { useIsMobileDevice } from "../../hooks/useIsMobileDevice";
import { useMedia } from "../../util";
import { sendDesktopUrl } from "../../backend/desktopLink";
import { ContinueOnDesktop, SendStatus } from "./ContinueOnDesktop";

/**
 * Blocks the dashboard on phones, offering to email the user a link they can
 * open once they are back at a computer.
 */
const ContinueOnDesktopGate: FunctionComponent = () => {
  const { account, logout } = useAppContext();
  const isMobileDevice = useIsMobileDevice();
  const M = useMedia();
  const [status, setStatus] = useState<SendStatus>("idle");

  // Desktop browsers narrowed past the medium breakpoint get the same
  // treatment: the dashboard has no layout below it.
  const isTooNarrow = !M.isGTMedium;

  // `account.id` is 0 until the session resolves, and again after logout.
  if ((!isMobileDevice && !isTooNarrow) || account?.id === 0) {
    return null;
  }

  const sendLink = async () => {
    setStatus("sending");
    try {
      await sendDesktopUrl();
      setStatus("sent");
    } catch (error) {
      console.error("[ContinueOnDesktop] send-desktop-url failed", error);
      setStatus("error");
    }
  };

  return (
    <ContinueOnDesktop
      status={status}
      onSendLink={sendLink}
      onLogout={logout}
    />
  );
};

export { ContinueOnDesktopGate };
export default ContinueOnDesktopGate;
